import { action, computed, makeObservable, observable } from 'mobx';

const storage = localStorage;
const ACCESS_TOKEN = 'accessToken';

export class Auth {
  @observable accessToken = storage.getItem(ACCESS_TOKEN) || '';

  constructor() {
    makeObservable(this);
  }

  @action
  setToken = (token: string) => {
    try {
      storage.setItem(ACCESS_TOKEN, token);
    } finally {
      this.accessToken = token;
    }
  };

  @action
  getToken = () => {
    return this.accessToken;
  };

  @computed
  get loggedIn(): boolean {
    return !!this.accessToken;
  }
}

export default new Auth();
